export const HOME = {
  emergentLink: "home-emergent-link",
  heroCta: "home-hero-cta",
  studentLoginBtn: "home-student-login-btn",
  teacherLoginBtn: "home-teacher-login-btn",
  managerLoginBtn: "home-manager-login-btn",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  programs: "nav-programs",
  announcements: "nav-announcements",
  contact: "nav-contact",
  loginMenu: "nav-login-menu",
  loginStudent: "nav-login-student",
  loginTeacher: "nav-login-teacher",
  loginManager: "nav-login-manager",
  mobileToggle: "nav-mobile-toggle",
  logout: "nav-logout",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitBtn: "auth-submit-btn",
  roleTabStudent: "auth-role-tab-student",
  roleTabTeacher: "auth-role-tab-teacher",
  roleTabManager: "auth-role-tab-manager",
  errorAlert: "auth-error-alert",
};

export const DASH = {
  managerRoot: "dashboard-manager-root",
  teacherRoot: "dashboard-teacher-root",
  studentRoot: "dashboard-student-root",
  sidebar: "dashboard-sidebar",
};
